module.exports = __webpack_public_path__ + "img/combine_cells.03ffae05.svg";